import { ComercioActivoService } from 'src/app/services/merchant/comercio-activo.service';
import { MerchantService } from 'src/app/services/merchant/merchant.service';
import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Router, NavigationEnd, NavigationStart } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { AuthService } from 'src/app/services/auth/auth.service';
import { environment } from '../../../environments/environment';
import { filter } from 'rxjs/operators';
import { BehaviorSubject, Subscription } from 'rxjs';
import { puedeVerIA } from 'src/app/services/ia/ia-formato';
import { MulticomercioDashboardComponent } from '../multicomercio-dashboard/multicomercio-dashboard.component';

import { LiquidacionService } from 'src/app/services/liquidacion/liquidacion.service';
@Component({
  selector: 'app-side-bar',
  templateUrl: './side-bar.component.html',
  styleUrls: ['./side-bar.component.css']
})
export class SideBarComponent implements OnInit, OnDestroy {

  isAuth: any;
  sessionUser: any;
  activeMenu: any;
  menuOption: any;
  sidebarOpen: boolean = false;
  sidebarCollapsed: boolean = false;
  env = environment;

  // RBAC reactivo
  hasRbac: boolean = false;
  rbacModules: Set<string> = new Set();
  private rbacSubs: Subscription[] = [];

  // BehaviorSubject para comunicar el estado del sidebar a otros componentes
  private sidebarCollapsedSubject = new BehaviorSubject<boolean>(false);
  public sidebarCollapsed$ = this.sidebarCollapsedSubject.asObservable();

  constructor(
    private router: Router,
    private sanitizer: DomSanitizer,
    public _auth: AuthService,
    private cdr: ChangeDetectorRef
  ,
    public _comercioActivo: ComercioActivoService,
    private _merchantSrv: MerchantService,
    private _liq: LiquidacionService) { }

  // FIR-03 (Mario, 14-oct): cuántas tandas esperan la firma de quien mira (se repasa cada 5 minutos).
  porFirmar = 0;
  private relojFirmas: any = null;
  private contarPorFirmar = async (): Promise<void> => {
    if (!this._auth.hasPermission || !this._auth.hasPermission('liquidacion.aprobar')) { this.porFirmar = 0; return; }
    if (!localStorage.getItem('x-token')) return;   // sin sesión lista todavía, no pregunta
    try { const r = await this._liq.porAprobarDeFondo(); this.porFirmar = ((r && r.tandas) || []).length; } catch (e) { }
  };

  ngOnInitComercio(): void {
    this.comercioActivo = this._comercioActivo.codigo;
    this.cargarComercios();
  }

  ngOnInit(): void {
    this.ngOnInitComercio();
    // Suscribirse a los cambios de autenticación
    this._auth.auth$.subscribe((rep: any) => {
      this.isAuth = rep;
      this.sessionUser = rep ? this._auth.sessionUser : null;

      if (rep) {
        void this.contarPorFirmar();
        if (!this.relojFirmas) this.relojFirmas = setInterval(() => void this.contarPorFirmar(), 5 * 60 * 1000);
        if (this.sessionUser?.role != 'COMPUTER_ROLE') {
          this.activeMenu = true;
        }

        // Establecer la opción de menú activa basada en la ruta actual
        this.setActiveMenuFromRoute();
      }
    });

    // Suscribirse a los cambios de opción de menú
    this._auth.menuOption.subscribe((rep: any) => {
      this.menuOption = rep;
    });

    // RBAC reactivo: suscribirse a hasRbac$ y permissions$
    this.rbacSubs.push(
      this._auth.hasRbac$.subscribe((val: boolean) => {
        this.hasRbac = val;
        this.cdr.markForCheck();
      })
    );
    this.rbacSubs.push(
      this._auth.permissions$.subscribe((perms: any[]) => {
        this.rebuildModuleAccess(perms);
        this.cdr.markForCheck();
      })
    );

    // La ruta a la que se entra, ANTES de que la pantalla pida sus datos: el
    // interceptor la usa para decidir si manda el comercio.
    this.router.events
      .pipe(filter(event => event instanceof NavigationStart))
      .subscribe((event: any) => this._comercioActivo.marcarRuta(event.url));

    // Suscribirse a los cambios de ruta para actualizar el menú activo
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        this._comercioActivo.marcarRuta(event.urlAfterRedirects);
        this.selectorVisible = this._comercioActivo.aplicaEn(event.urlAfterRedirects);
        this.setActiveMenuFromRoute();
      });

    this.selectorVisible = this._comercioActivo.aplicaEn(this.router.url);

    // Establecer la opción de menú activa al inicializar
    this.setActiveMenuFromRoute();
  }

  ngOnDestroy(): void {
    this.rbacSubs.forEach(s => s.unsubscribe());
  }

  // Mapeo inverso: categoría backend → módulo frontend UI (sidebar)
  // contactos solo mapea a 'contactos' — cupo/planes/pagos/etc NO activan sidebar de contactos
  private readonly CATEGORY_TO_MODULE: { [backendCat: string]: string } = {
    contactos: 'contactos',
    cupo: 'contactos',
    planes: 'contactos',
    compras_financiadas: 'contactos',
    gestion_cobro: 'contactos',
    pagos: 'contactos',
    finanzas: 'finanzas',
    cobranza: 'cobranza',
    credito: 'credito',
    config: 'config',
    reportes: 'reportes',
    ventas: 'ventas',
    admin: 'admin',
    productos_compra: 'productos_compra',
  };

  private rebuildModuleAccess(perms: any[]): void {
    const modules = new Set<string>();
    for (const p of perms) {
      const code = typeof p === 'string' ? p : p?.code;
      if (!code) continue;
      if (code === '*.*.*') {
        ['contactos','ventas','finanzas','cobranza','credito','config','reportes','admin','productos_compra'].forEach(m => modules.add(m));
        break;
      }
      const backendCat = code.split('.')[0];
      if (backendCat === '*') {
        ['contactos','ventas','finanzas','cobranza','credito','config','reportes','admin','productos_compra'].forEach(m => modules.add(m));
        break;
      }
      const frontendModule = this.CATEGORY_TO_MODULE[backendCat] || backendCat;
      if (frontendModule) modules.add(frontendModule);
    }
    this.rbacModules = modules;
  }

  /** La entrada «Inteligencia artificial»: la regla vive en `services/ia/ia-formato.ts`. */
  get verIA(): boolean { return puedeVerIA(this._auth); }

  /** El ítem «Multicomercio»: se ve si el panel tiene al menos un recuadro para quien mira. */
  get verMulticomercio(): boolean { return MulticomercioDashboardComponent.algunaVisible(this._auth); }

  /** ¿Estamos en `console/ia`? Allí el selector de comercio de la cabecera no gobierna nada. */
  get enIA(): boolean {
    const u = this.router.url.split('?')[0].split('#')[0];
    return u === '/console/ia' || u.startsWith('/console/ia/');
  }

  canAccessModule(moduleName: string): boolean {
    if (this.hasRbac) {
      return this.rbacModules.has(moduleName);
    }
    return false;
  }

  // Método para establecer la opción de menú activa basada en la ruta actual
  setActiveMenuFromRoute(): void {
    const currentUrl = this.router.url;

    // Dashboard oculto - no establecer opción de menú
    // if (currentUrl.includes('/console/dashboard')) {
    //   this.setOptionMenu(0);
    // } else
    if (currentUrl.includes('/console/create-constacts')) {
      this.setOptionMenu(1);
    } else if (currentUrl.includes('/console/ventas')) {
      this.setOptionMenu(2);
    } else if (currentUrl.includes('/console/finanzas2')) {
      this.setOptionMenu(4);
    } else if (currentUrl.includes('/console/cobranza')) {
      this.setOptionMenu(6);
    } else if (currentUrl.includes('/console/credito')) {
      this.setOptionMenu(7);
    } else if (currentUrl.includes('/console/parametros-sistema')) {
      this.setOptionMenu(8);
    } else if (currentUrl.includes('/console/multicomercio') || currentUrl.includes('/console/liquidacion')
      || currentUrl.includes('/console/documentacion-integracion')) {
      // Panel de Multicomercio (21-oct) y las pantallas que cuelgan de él: todas encienden el ítem 21.
      this.setOptionMenu(21);
    } else if (currentUrl.includes('/console/organizacion')) {
      this.setOptionMenu(21);
    } else if (currentUrl.includes('/console/merchants')) {
      this.setOptionMenu(21);
    } else if (currentUrl.includes('/console/solicitudes-credito')) {
      this.setOptionMenu(21);
    } else if (currentUrl.includes('/console/tipos-flujos')) {
      this.setOptionMenu(21);
    } else if (currentUrl === '/console/workflows' || currentUrl.startsWith('/console/workflows/') || currentUrl.startsWith('/console/workflows?')) {
      this.setOptionMenu(21);
    } else if (currentUrl === '/console/altas' || currentUrl.startsWith('/console/altas/') || currentUrl.startsWith('/console/altas?')) {
      this.setOptionMenu(21);
    } else if (currentUrl === '/console/ia' || currentUrl.startsWith('/console/ia/') || currentUrl.startsWith('/console/ia?')) {
      // Inteligencia artificial (18). Por prefijo exacto y no `includes`: ninguna
      // otra ruta empieza así hoy, pero `includes('/console/ia')` encendería esta
      // opción el día que exista algo como `/console/iabc`.
      this.setOptionMenu(21);
      // Va ANTES de '/console/caja' (el simulador, opción 10) por prudencia: hoy
      // «cierre-de-caja» no contiene esa cadena, pero si algún día la ruta del
      // simulador se acorta, el que pierde es el que está declarado después.
    } else if (currentUrl.includes('/console/cierre-de-caja')) {
      this.setOptionMenu(16);
    } else if (currentUrl.includes('/console/export')) {
      this.setOptionMenu(9);
    } else if (currentUrl.includes('/console/caja')) {
      this.setOptionMenu(10);
    } else if (currentUrl.includes('/console/estadisticas')) {
      this.setOptionMenu(2);
    } else if (currentUrl.includes('/console/finacial-dashboard')) {
      this.setOptionMenu(3);
    } else if (currentUrl.includes('/console/credit-option')) {
      this.setOptionMenu(5);
    }
  }

  // Métodos para controlar el sidebar en móvil
  toggleSidebar(): void {
    this.sidebarOpen = !this.sidebarOpen;
  }

  closeSidebar(): void {
    this.sidebarOpen = false;
  }

  // Nuevo método para colapsar/expandir el sidebar en desktop
  toggleSidebarCollapse(): void {
    this.sidebarCollapsed = !this.sidebarCollapsed;
    // Emitir el nuevo estado a otros componentes
    this.sidebarCollapsedSubject.next(this.sidebarCollapsed);
  }

  // Método para obtener el estado actual del sidebar
  getSidebarCollapsedState(): boolean {
    return this.sidebarCollapsed;
  }

  // Método para sanitizar URLs
  sanitize(url: string) {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

  // Método para establecer la opción de menú activa
  setOptionMenu(opt: any): void {
    this._auth.setmenuOption(opt);
    this.closeSidebar(); // Cerrar sidebar en móvil después de seleccionar
  }

  // Método para cerrar sesión
  logout(): void {
    this.router.navigate([environment.logoutRoute], {});
  }

  /**
   * ══════════════════════════════════════════════════════════════════════════
   * EL RÓTULO DE LA BARRA SUPERIOR — qué dice, y cuándo se calla.
   * ══════════════════════════════════════════════════════════════════════════
   *
   * 🔴 Tenía DOS defectos opuestos, los dos medidos el 2026-09-20:
   *
   *   1. En Organización y en Comercios no había entrada, así que la barra
   *      decía «CrediTotal» — el nombre de la empresa, que no ubica a nadie:
   *      en la consola de CrediTotal todo es CrediTotal.
   *   2. En las dos que sí conocía —Solicitudes de crédito y Tipos y flujos— el
   *      nombre salía DOS VECES, una acá y otra en el `<h1>` de la página, uno
   *      debajo del otro. Y una tercera en el menú de la izquierda, que además
   *      pinta de azul dónde estás.
   *
   * LA REGLA QUE QUEDA: **la barra dice dónde estás sólo cuando la página no lo
   * dice.** En un listado, el `<h1>` de la página ya lo dice y el menú lo
   * resalta: la barra se calla. En una ficha —donde el `<h1>` es el nombre del
   * comercio, el código de la solicitud o el del flujo— la barra dice el módulo,
   * que es el dato que ahí falta.
   *
   * 📍 El `<h1>` es el que se queda porque es el que lleva el renglón de
   * identificación y los botones de la pantalla; sacarlo dejaría los botones
   * flotando. Y de paso la página vuelve a tener UN solo `<h1>`: la barra usa
   * ahora un `<p>` (ver el marcado), que era otro defecto — dos encabezados de
   * nivel 1 en la misma página.
   */
  /** Los listados cuyo propio `<h1>` ya dice el nombre del módulo. */
  private readonly SIN_ROTULO = [
    '/console/organizacion',
    '/console/merchants',
    '/console/solicitudes-credito',
    '/console/tipos-flujos',
    '/console/workflows',
    '/console/altas',
  ];

  // Método para obtener el título de la página actual
  getPageTitle(): string {
    // Sin la cadena de consulta ni el ancla: un `?tab=…` no cambia dónde estás.
    const url = this.router.url.split('?')[0].split('#')[0].replace(/\/+$/, '');

    if (this.SIN_ROTULO.includes(url)) return '';
    // Las pantallas que cuelgan de un comercio: la ficha, sus siete pantallas
    // hijas, el alta y la edición. Todas tienen su propio título —el nombre del
    // comercio— así que acá va el módulo.
    if (url.startsWith('/console/merchants/')) return 'Comercios';
    if (url === '/console/liquidacion' || url.startsWith('/console/liquidacion/')) return 'Liquidación';
    if (url.startsWith('/console/organizacion/')) return 'Organización';
    // Un workflow: su `<h1>` es el nombre del workflow; aquí va el módulo.
    if (url.startsWith('/console/workflows/')) return 'Workflows';
    if (url.startsWith('/console/altas/')) return 'Altas de comercios';
    // Inteligencia artificial: su `<h1>` lo dice en las cinco solapas.
    if (url === '/console/ia' || url.startsWith('/console/ia/')) return '';

    if (url.includes('/console/create-constacts')) return 'Contactos';
    if (url.includes('/console/ventas')) return 'Ventas';
    if (url === '/console/multicomercio') return 'Multicomercio';
    if (url.includes('/console/finanzas2')) return 'Finanzas';
    if (url.includes('/console/finacial-dashboard')) return 'Dashboard Financiero';
    if (url.includes('/console/credit-option')) return 'Consola Administrativa';
    if (url.includes('/console/estadisticas')) return 'Estadísticas';
    if (url.includes('/console/plans')) return 'Planes';
    if (url.includes('/console/users')) return 'Usuarios';
    if (url.includes('/console/recargas')) return 'Recargas';
    if (url.includes('/console/ganancias')) return 'Ganancias';
    if (url.includes('/console/payments')) return 'Pagos';
    if (url.includes('/console/notifications')) return 'Notificaciones';
    if (url.includes('/console/cobranza')) return 'Cobranza';
    if (url.includes('/console/credito')) return 'Crédito';
    if (url.includes('/console/parametros-sistema')) return 'Parámetros del Sistema';
    if (url.includes('/console/catalog-products')) return 'Productos';
    if (url.includes('/console/solicitudes-credito')) return 'Solicitudes de crédito';
    if (url.includes('/console/tipos-flujos')) return 'Tipos y pasos del cliente';
    if (url.includes('/console/cierre-de-caja')) return 'Cierre de caja';
    if (url.includes('/console/cash-register-simulator')) return 'Simulador de Caja';
    // Dashboard oculto
    // if (url.includes('/console/dashboard')) return 'Dashboard';

    return 'CrediTotal';
  }

  // ══ SELECTOR DE COMERCIO ════════════════════════════════════════════════════
  //
  // 🔴 Va en la barra superior a propósito: tiene que estar SIEMPRE visible.
  // Si no se ve cuál comercio se está mirando, alguien va a leer un número
  // creyendo que es de toda la red.

  comercios: any[] = [];
  comercioActivo: string | null = null;
  /** Solo en las pantallas que separan por comercio (ComercioActivoService.aplicaEn). */
  selectorVisible = false;
  cargandoComercios = false;

  cargarComercios = async (): Promise<void> => {
    if (this.comercios.length || this.cargandoComercios) return;
    this.cargandoComercios = true;
    try {
      const rep = await this._merchantSrv.getMerchants({ state: 'ACTIVE' });
      // Los proveedores de servicio (aseguradoras) también se consultan aquí: sus ventas son las pólizas.
      this.comercios = rep?.merchants || rep || [];
    } catch { this.comercios = []; }
    finally { this.cargandoComercios = false; }
  };

  elegirComercio = (codigo: string | null): void => {
    this._comercioActivo.seleccionar(codigo);
    this.comercioActivo = this._comercioActivo.codigo;
    // Recargar es lo honesto: la pantalla que se está viendo ya trajo sus datos
    // con el comercio anterior. Refrescar solo el selector mostraría un comercio
    // y los datos de otro.
    window.location.reload();
  };

  get nombreComercioActivo(): string {
    if (!this.comercioActivo) return 'Todos los comercios';
    const c = this.comercios.find(x => x.code === this.comercioActivo);
    return c ? c.name : this.comercioActivo;
  }
}
